module.exports = __webpack_public_path__ + "img/17_20.cada06e3.png";